<template>
  <CHeader fixed light>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      v-c-emit-root-event:toggle-sidebar-mobile
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      v-c-emit-root-event:toggle-sidebar
    />
    <CHeaderNav class="mr-4 position-absolute profile-logo-icon">
      <TheProfileHeaderDropdownAccnt/>
    </CHeaderNav>
  </CHeader>
</template>

<style>
  .profile-logo-icon {
    right: 0;
    top: 8px;
  }
</style>

<script>
import TheProfileHeaderDropdownAccnt from "./TheProfileHeaderDropdownAccnt";

export default {
  name: 'TheProfileHeader',
  components: {
    TheProfileHeaderDropdownAccnt,
  }
}
</script>
